import * as React from 'react';
import { Menu, Container, Button, Image, Popup } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { HashLink } from "react-router-hash-link";
import { menuItems } from './MenuItems';

interface Props {
    fixed?: boolean;
    activeMenu: string;

}

interface MenuPopupProps {
    activeMenu: string,
    name: string,
    label: string
}

const MenuPopup: React.SFC<MenuPopupProps> = ({ activeMenu, name, label, children }) =>
    <Popup hoverable basic style={{ padding: 0, border: "none", marginTop: 0 }}
    trigger={<Menu.Item active={activeMenu == name}>{label}</Menu.Item>}                
    position='bottom center'
    >
        {children}
    </Popup>

const DesktopMenu = ({ fixed, activeMenu }: Props) =>
    <Menu
        id="desktop-menu"
        fixed={fixed ? 'top' : undefined}
        inverted={!fixed}
        secondary={!fixed}
        borderless
        pointing
        style={{ border: fixed ? undefined : "none" }}
        size='large'
    >
        <Container>

            <Menu.Item as={Link} to="/"
                style={{ paddingBottom: fixed ? 0 : 4, paddingTop: 0 }}>
                <Image
                    src={fixed ? "/images/logo-medium-light.png" : "/images/logo-medium-dark.png"}
                    height={35}
                />
            </Menu.Item>

            <Menu.Item as={Link} to="/services">Services</Menu.Item>

            <MenuPopup name="company" activeMenu={activeMenu} label="Company">
                <Menu vertical style={{ width: 130 }}>
                    { 
                        menuItems.company.map(i => 
                            <Menu.Item key={i.label} as={HashLink} to={i.url} name={i.label} />) 
                    }
                </Menu>
            </MenuPopup>

            <Menu.Item as={Link} to="/social">Social</Menu.Item>

            <MenuPopup name="faq" activeMenu={activeMenu} label="FAQ">
                <Menu vertical style={{ width: 180 }}>
                    { 
                        menuItems.faq.map(i => 
                            <Menu.Item key={i.label} as={HashLink} to={i.url} name={i.label} />) 
                    }
                </Menu>
            </MenuPopup>

            <Menu.Item position='right'>
                <Button as={Link} primary={fixed} to="/sign-up" inverted={!fixed}>Sign Up</Button>
            </Menu.Item>

        </Container>
    </Menu>

export default DesktopMenu;


// WEBPACK FOOTER //
// ./src/common/DesktopMenu.tsx